module.exports = __webpack_public_path__ + "img/bout-ensemble.768d07f0.jpeg";